module.exports = __webpack_public_path__ + "static/img/订@2x.23244fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/订@2x.png
// module id = i4xM
// module chunks = 192